import type { ReactNode } from "react";
import starsVideo from "../../assets/videos/stars.mp4";
import styles from "./authPage.css";

export default function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className={styles.pageWrapper}>
      <video
        className={styles.backgroundVideo}
        src={starsVideo}
        autoPlay
        muted
        loop
        playsInline
      />
      {children}
    </div>
  );
}
